import {
  ChangeDetectionStrategy,
  Component, EventEmitter, Inject,
  Input, OnInit, Output
} from "@angular/core";
import {OrderModel} from "../../../models/order.model";
import {OmsOrderStatusType} from "../../../types/oms-order-status.type";

require('./oms-order-action-menu.scss');
@Component({
  standalone: false,
  selector: 'app-oms-order-action-menu',
  templateUrl: './oms-order-action-menu.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OmsOrderActionMenuComponent implements OnInit {

  @Input() order: OrderModel;
  @Input() deliverySchedulingStateReference: any;
  @Input() canRecover: boolean;

  @Output() onSendToDispatch = new EventEmitter<string>();
  @Output() onAddNote = new EventEmitter<string>();
  @Output() onSetOrderOnHold = new EventEmitter<string>();
  @Output() onResumeOrder = new EventEmitter<string>();
  @Output() onManuallyCompleteOrder = new EventEmitter<string>();
  @Output() onEdit = new EventEmitter<OrderModel>();
  @Output() onDuplicate = new EventEmitter<string>();
  @Output() onPrintBillOfLading = new EventEmitter<string>();
  @Output() onDownloadBillOfLading = new EventEmitter<string>();
  @Output() onSendSchedulingSMSClicked = new EventEmitter<OrderModel>();
  @Output() onSendSchedulingWhatsappClicked = new EventEmitter<OrderModel>();
  @Output() onViewSchedulingLink = new EventEmitter<string>();
  @Output() onRecover = new EventEmitter<string>();
  @Output() onCancelOrder = new EventEmitter<string>();

  public orderStatuses: typeof OmsOrderStatusType = OmsOrderStatusType;
  public allowPrintingBillOfLading: boolean;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.allowPrintingBillOfLading = this.splitService.isPrintingBillOfLadingAllowed();
  }
}
